import type { Channel } from "@/utils/fileImport/channels"
import { ALPHA_QUANTITY_SOLD, ALPHA_VARIANT_ID } from "@/utils/alphaModel"

export const headers = [
  [
    "Sales Record Number",
    "Order Number",
    "Buyer Username",
    "Buyer Name",
    "Buyer Email",
    "Buyer Note",
    "Buyer Address 1",
    "Buyer Address 2",
    "Buyer City",
    "Buyer State",
    "Buyer Zip",
    "Buyer Country",
    "Buyer Tax Identifier Name",
    "Buyer Tax Identifier Value",
    "Ship To Name",
    "Ship To Phone",
    "Ship To Address 1",
    "Ship To Address 2",
    "Ship To City",
    "Ship To State",
    "Ship To Zip",
    "Ship To Country",
    "Item Number",
    "Item Title",
    "Custom Label",
    "Sold Via Promoted Listings",
    "Quantity",
    "Sold For",
    "Shipping And Handling",
    "Item Location",
    "Item Zip Code",
    "Item Country",
    "eBay Collect And Remit Tax Rate",
    "eBay Collect And Remit Tax Type",
    "eBay Reference Name",
    "eBay Reference Value",
    "Tax Status",
    "Seller Collected Tax",
    "eBay Collected Tax",
    "Electronic Waste Recycling Fee",
    "Mattress Recycling Fee",
    "Battery Recycling Fee",
    "White Goods Disposal Tax",
    "Tire Recycling Fee",
    "Additional Fee",
    "eBay Collected Charges",
    "Total Price",
    "eBay Collected Tax Included in Total",
    "Payment Method",
    "Commitment date",
    "Sale Date",
    "Paid On Date",
    "Ship By Date",
    "Minimum Estimated Delivery Date",
    "Maximum Estimated Delivery Date",
    "Shipped On Date",
    "Feedback Left",
    "Feedback Received",
    "My Item Note",
    "PayPal Transaction ID",
    "Shipping Service",
    "Tracking Number",
    "Transaction ID",
    "Variation Details",
    "Global Shipping Program",
    "Global Shipping Reference ID",
    "Click And Collect",
    "Click And Collect Reference Number",
    "eBay Plus",
    "Authenticity Verification Program",
    "Authenticity Verification Status",
    "Authenticity Verification Outcome Reason",
    "eBay Vault Program",
    "Vault Fulfillment Type",
    "eBay Fulfillment Program",
    "Tax City",
    "Tax State",
    "Tax Zip",
    "Tax Country",
    "eBay International Shipping",
  ],
  [
    "Sales Record Number",
    "Order Number",
    "Buyer Username",
    "Buyer Name",
    "Buyer Email",
    "Buyer Note",
    "Buyer Address 1",
    "Buyer Address 2",
    "Buyer City",
    "Buyer State",
    "Buyer Zip",
    "Buyer Country",
    "Buyer Tax Identifier Name",
    "Buyer Tax Identifier Value",
    "Ship To Name",
    "Ship To Phone",
    "Ship To Address 1",
    "Ship To Address 2",
    "Ship To City",
    "Ship To State",
    "Ship To Zip",
    "Ship To Country",
    "Item Number",
    "Item Title",
    "Custom Label",
    "Sold Via Promoted Listings",
    "Quantity",
    "Sold For",
    "Shipping And Handling",
    "Item Location",
    "Item Zip Code",
    "Item Country",
    "eBay Collect And Remit Tax Rate",
    "eBay Collect And Remit Tax Type",
    "eBay Reference Name",
    "eBay Reference Value",
    "Tax Status",
    "Seller Collected Tax",
    "eBay Collected Tax",
    "Electronic Waste Recycling Fee",
    "Mattress Recycling Fee",
    "Battery Recycling Fee",
    "White Goods Disposal Tax",
    "Tire Recycling Fee",
    "Additional Fee",
    "eBay Collected Charges",
    "Total Price",
    "eBay Collected Tax Included in Total",
    "Payment Method",
    "Sale Date",
    "Paid On Date",
    "Ship By Date",
    "Minimum Estimated Delivery Date",
    "Maximum Estimated Delivery Date",
    "Shipped On Date",
    "Feedback Left",
    "Feedback Received",
    "My Item Note",
    "PayPal Transaction ID",
    "Shipping Service",
    "Tracking Number",
    "Transaction ID",
    "Variation Details",
    "Global Shipping Program",
    "Global Shipping Reference ID",
    "Click And Collect",
    "Click And Collect Reference Number",
    "eBay Plus",
    "Authenticity Verification Program",
    "Authenticity Verification Status",
    "Authenticity Verification Outcome Reason",
    "eBay Vault Program",
    "Vault Fulfillment Type",
    "eBay Fulfillment Program",
    "Tax City",
    "Tax State",
    "Tax Zip",
    "Tax Country",
    "eBay International Shipping",
  ],
]

const channel: Channel = {
  headers,
  dateFormats: {
    Date: "MDY",
  },
  blockMap: {
    [ALPHA_QUANTITY_SOLD]: {
      target: "Quantity",
      columns: {
        [ALPHA_VARIANT_ID]: "Item title",
        Date: "Sale date",
      },
      notInFile: {
        Channel: "eBay",
      },
    },
  },
}

export default channel
